var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    _vm._l(_vm.items, function (item) {
      return _c("div", [
        _c("div", { staticClass: "card", staticStyle: { width: "100%" } }, [
          _c("div", { staticClass: "row" }, [
            _c("div", { staticClass: "col-12 col-md-9 border-right" }, [
              _c("div", { staticClass: "mt-05 ml-1" }, [
                _c("img", {
                  staticClass: "rounded m-05",
                  attrs: {
                    src:
                      _vm.event_info.event_image == null
                        ? "/images/cover.png"
                        : _vm.event_info.event_image.url,
                    height: "50",
                    width: "50",
                  },
                }),
              ]),
              _vm._v(" "),
              _c("div", [
                _c("h2", {
                  staticClass: "ml-1",
                  domProps: { textContent: _vm._s(item.title) },
                }),
                item.sold_out === 1
                  ? _c(
                      "div",
                      {
                        staticClass:
                          "badge badge-pill badge-glow badge-danger ml-1 mb-1",
                        staticStyle: { "font-size": "1rem" },
                      },
                      [_vm._v(_vm._s(_vm.__("event.sold_out")))]
                    )
                  : _vm._e(),
              ]),
              _vm._v(" "),
              _c("div", [
                _c("p", {
                  staticClass: "ml-1",
                  domProps: {
                    innerHTML: _vm._s(
                      item.description.replace(/(?:\r\n|\r|\n)/g, "<br>")
                    ),
                  },
                }),
              ]),
            ]),
            _vm._v(" "),
            item.plan_price !== null ||
            item.price !== null ||
            item.quantity_available === 0
              ? _c(
                  "div",
                  { staticClass: "col-12 col-md-3 pt-05 text-center" },
                  [
                    _vm.price_setting === "plan-price"
                      ? _c("span", { staticClass: "font-large-1" }, [
                          _vm._v(
                            _vm._s(
                              _vm._f("currency")(item.plan_price, _vm.site_tax)
                            )
                          ),
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.price_setting === "one-price"
                      ? _c("span", { staticClass: "font-large-1" }, [
                          _vm._v(
                            _vm._s(_vm._f("currency")(item.price, _vm.site_tax))
                          ),
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "span",
                      {
                        staticClass: "font-small-1 text-muted d-block",
                        staticStyle: { "margin-top": "-5px" },
                      },
                      [_vm._v("inc " + _vm._s(_vm.site_tax.name))]
                    ),
                    _vm._v(" "),
                    _c(
                      "span",
                      {
                        staticClass: "font-small-1 text-muted d-block",
                        staticStyle: { "margin-top": "-5px" },
                      },
                      [_vm._v(_vm._s(item.purchase_count) + " sold")]
                    ),
                    _vm._v(" "),
                    _vm.allowPurchase
                      ? _c("div", { staticClass: " mt-05" }, [
                          _c(
                            "span",
                            { staticClass: "font-small-2 text-center" },
                            [_vm._v("Quantity:")]
                          ),
                          _vm._v(" "),
                          _c("div", { staticClass: "d-flex mb-05 mt-05" }, [
                            item.sold_out === 0
                              ? _c("div", { staticClass: "m-auto" }, [
                                  _c("input", {
                                    staticClass: "touchspin form-control",
                                    staticStyle: { width: "75px" },
                                    attrs: {
                                      id: "qty-" + item.id,
                                      type: "number",
                                      name: "qty[" + item.id + "]",
                                    },
                                    domProps: {
                                      value: _vm.items.length === 1 ? 1 : "",
                                    },
                                    on: {
                                      change: function ($event) {
                                        return _vm.checkQty(
                                          item.id,
                                          item.qty,
                                          $event
                                        )
                                      },
                                    },
                                  }),
                                  _vm._v(" "),
                                  _c("div", {
                                    staticClass:
                                      "ml-auto text-danger help-block font-small-1",
                                    attrs: {
                                      id: "error-" + item.id,
                                      role: "alert",
                                    },
                                  }),
                                ])
                              : _vm._e(),
                          ]),
                        ])
                      : _vm._e(),
                  ]
                )
              : _c("div", { staticClass: "col-12 col-md-3" }, [
                  _vm._m(0, true),
                ]),
          ]),
        ]),
      ])
    }),
    0
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "d-flex h-100" }, [
      _c("div", { staticClass: "justify-content-center align-self-center" }, [
        _vm._v(
          "\n                        Not available for purchase\n                    "
        ),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }